import { COLLECTIONS } from "constants/action-types";

export const mutateDefaultItem = (collectionId: string, item: any, value) => ({
    payload: {
        item,
        collectionId,
        value,
    },
    type: COLLECTIONS.COLLECTION.ITEMS.DEFAULT_ITEM.MUTATE,
});
